import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Bannière flash éphémère (succès) affichée dans la barre de navigation.
 */
@Injectable({
  providedIn: 'root',
})
export class FlashService {
  private readonly messageSubject = new BehaviorSubject<string | null>(null);
  private timerId: ReturnType<typeof setTimeout> | null = null;

  /** Flux du message courant ({@code null} = masqué). */
  readonly message$ = this.messageSubject.asObservable();

  constructor(private readonly translate: TranslateService) {}

  /** Affiche un message ; `message` peut être une clé i18n ou un libellé déjà traduit. */
  success(message: string, durationMs = 3200): void {
    this.clearTimer();
    const translated = this.translate.instant(message);
    this.messageSubject.next(translated === message ? message : translated);
    this.timerId = setTimeout(() => this.clear(), durationMs);
  }

  /** Masque le message immédiatement. */
  clear(): void {
    this.clearTimer();
    this.messageSubject.next(null);
  }

  private clearTimer(): void {
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }
}
